import { Users2Icon, ClipboardListIcon, AlertTriangleIcon, BellIcon, CreditCardIcon } from 'lucide-react';
import type { NavigationSectionConfig } from './types';

/**
 * Clients and Policies Navigation Section
 * Farmers, Quotes, Policies, Claims, and Notifications
 */
export const clientsPoliciesSections: NavigationSectionConfig[] = [
  {
    id: 'clients-policies-section',
    label: 'Clients and Policies',
    topNavId: 'clients-policies',
    items: [
      {
        id: 'farmers',
        label: 'Farmers',
        path: '/admin/farmers',
        icon: <Users2Icon size={18} />,
        permissions: ['nav:farmers']
      },
      {
        id: 'quotes',
        label: 'Quotes/Policies',
        path: '/admin/quotes',
        icon: <ClipboardListIcon size={18} />,
        permissions: ['nav:quotes']
      },
      {
        id: 'claims',
        label: 'Claims',
        path: '/claims',
        icon: <AlertTriangleIcon size={18} />,
        permissions: ['nav:claims']
      },
      {
        id: 'claims-payments',
        label: 'Claims Payments',
        path: '/claims-payments',
        icon: <CreditCardIcon size={18} />,
        permissions: ['nav:claims']
      },
      {
        id: 'notifications',
        label: 'Notifications',
        path: '/admin/notifications',
        icon: <BellIcon size={18} />,
        permissions: ['nav:notifications']
      }
    ]
  }
];

